module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/clins/clins.component.css
// module id = ./src/app/clins/clins.component.css
// module chunks = main